import { create } from "zustand";
import { persist } from "zustand/middleware";

// Single-user bearer token, persisted to localStorage. Documented tradeoff vs
// in-memory: acceptable here (HTTPS, no third-party scripts served).
//
// `authed` is set once a token (possibly empty, for an open server) has been
// validated against /api/v1/system, so the route guard works in both modes.
interface AuthState {
  token: string;
  authed: boolean;
  setSession: (t: string) => void;
  clear: () => void;
}

export const useAuth = create<AuthState>()(
  persist(
    (set) => ({
      token: "",
      authed: false,
      setSession: (t) => set({ token: t.trim(), authed: true }),
      clear: () => set({ token: "", authed: false }),
    }),
    { name: "evo-console-auth" },
  ),
);

// Non-hook accessor for the fetch/WS layer (outside React render).
export function currentToken(): string {
  return useAuth.getState().token;
}
